<template>
    <Navbar></Navbar>
    <div class="product-page">
        <div class="product-kv">
            <div class="swiper-container kv-container" ref="swiperRefs">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <video class="pc-pad" data-src="/assets/product/engine/engine-kv1.mp4" alt="" muted loop
                                autoplay playsinline webkit-playsinline="true" x5-video-player-type="h5"
                                x5-video-player-fullscreen="true"></video>
                            <video class="mb-only" data-src="/assets/product/engine/engine-kv1-m.mp4" alt="" muted loop
                                autoplay playsinline webkit-playsinline="true" x5-video-player-type="h5"
                                t7-video-player-type="inline" x5-video-player-fullscreen="true"></video>
                        </div>
                        <div class="text-box">
                            <div class="title">
                                动力系统 <br v-if="!isPc"> 适配全场景应用
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>


        <div class="product-content">
            <div class="product-content-item" v-for="(item, index) in swiperData">
                <div class="content-item-t">
                    {{ item.name }}
                </div>

                <div class="img-box content-item-img">
                    <img :src="item.imgBg" alt="">
                </div>

                <div class="content-item-list">
                    <a v-for="(value, index) in item.itemData" :key="index" :href="value.productUrl" target="_blank">
                        {{ value.name }}
                    </a>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, nextTick, onUnmounted, watch } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import { listSecond, productList } from '@/utils/common.js'

const swiperRefs = ref(null);
const swiperInstances = ref([]);

const isPc = ref( window.innerWidth > 768 )


const initAllSwipers = async () => {
    await nextTick();
    const el = swiperRefs.value;
    if (el) {
        const swiper = new Swiper(el, {
            speed: 1300,
            pagination: {
                el: el.querySelector(".swiper-pagination"),
                clickable: true,
            },
            direction: "horizontal",
            simulateTouch: true,
            breakpoints: {
                768: {},
                1024: {}
            },
            on: {
                init: function () { },
                slideChangeTransitionStart(swiper) {
                    let swiperIndex = swiper.realIndex;
                },
            },
        });
        swiperInstances.value.push(swiper);
    }
};

const swiperData = ref([])
const imgList = ref([
    "/assets/product/engine/4B15L/4B15L.jpg",
    "/assets/product/engine/4C20B/4C20B.jpg",
    "/assets/product/engine/6Z30/6Z30.jpg",
    "/assets/product/engine/8Z40/8Z40.jpg",
    "/assets/product/engine/4D20M/4D20M.jpg",
    "/assets/product/engine/4D24/4D24.jpg",
    "/assets/product/engine/4f30.jpg",
    "/assets/product/engine/8P68MYL/8P68MYL.jpg",
])


const getListSecond = async () => {
    try {
        const res = await listSecond({
            pageNum: 1,
            pageSize: 20,
            categoryId: 1,
            publishStatus: 3
        });
        const tempData = res.rows.map(item => ({
            ...item,
            itemData: [],
            imgBg: ''
        }));
        swiperData.value = tempData;
        await Promise.all(
            tempData.map((item, index) => getSecondData(item.id, index))
        );

    } catch (error) {
        console.error('获取二级列表失败:', error);
    }
};

const getSecondData = async (id, index) => {
    try {
        const response = await productList({
            pageNum: 1,
            pageSize: 20,
            categoryId: 1,
            categorySecondId: id,
            publishStatus: 3
        });
        if (swiperData.value[index]) {
            swiperData.value[index].itemData = response.rows || [];
            swiperData.value[index].imgBg = imgList.value[index];
        }
    } catch (error) {
        console.error(`获取子数据失败(id:${id}):`, error);
        if (swiperData.value[index]) {
            swiperData.value[index].itemData = [];
        }
    }
};


onMounted(() => {
    initAllSwipers();
    getListSecond();
});

onUnmounted(() => {
});
</script>

<script>
export const pageConfig = {
    title: '动力系统 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'engine.html'
};

import { createApp } from 'vue';
import App from './engine.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./engine.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped>
// 原有样式保持不变
.product-kv {
    min-height: 100vh;
}

.kv-container {
    width: 100%;
    height: auto;

    .text-box {
        position: absolute;
        top: 2.34rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.5rem;

        .title {
            font-size: 0.5rem;
            font-weight: 800;
        }

        .text {
            font-size: 0.2rem;
            font-weight: 300;
        }

        .product-kv-btn {
            background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
            width: 1.71rem;
            height: 0.45rem;
            border-radius: 0.26rem;
            display: flex;
            justify-content: center;
            align-items: center;

            div {
                color: #fff;
                font-size: 0.13rem;
                font-weight: 400;
                width: 70%;
                text-align: center;
            }

            img {
                width: 0.25rem;
                height: 0.25rem;
                object-fit: cover;
            }
        }
    }
}

.product-content {
    padding: 0 1.56rem;
    width: calc(100% - 3.12rem);
    margin-top: 1.17rem;
    margin-bottom: 1.17rem;
    display: flex;
    flex-wrap: wrap;
    gap: 0.21rem;
    justify-content: space-between;

    .product-content-item {
        width: 3.86rem;
        min-height: 4.3rem;
        background: #F8FAFB;
        border-radius: 0.15rem;
        position: relative;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;


        .content-item-t {
            height: 0.64rem;
            background: #f4f4f4;
            display: flex;
            align-items: center;
            padding-left: 0.39rem;
            width: calc(100% - 0.39rem);
            color: #000;
            font-weight: 600;
            font-size: 0.22rem;
        }

        .content-item-img {
            width: 2.62rem;
        }

        .content-item-list {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            gap: 0.1rem;

            position: absolute;
            bottom: 0.37rem;
            left: 2%;
            width: 96%;

            a {
                padding: 0.02rem 0.04rem;
                border: 1px solid #676767;
                border-radius: 0.3rem;
                font-size: 0.08rem;
                transition: all 0.3s ease;

                &:hover {
                    background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
                    color: #fff;
                    border: 1px solid #E70012;
                }
            }
        }

        &:nth-child(n + 4) {
            width: 3.86rem;
        }
    }
}

@media (max-width: 768px) {

    .product-kv {
        min-height: auto;
    }

    .kv-container {
        .text-box {
            top: 2.69rem;
            width: auto;
            text-wrap: nowrap;
            .title {
                text-align: center;
            }
        }
    }

    .product-content {
        padding: 1.1rem 0.45rem 0;
        width: calc(100% - 0.9rem);
        flex-direction: column;
        margin-top: 0;

        .product-content-item {
            width: 100% !important;
            height: auto;
            padding-bottom: 0.5rem;

            .content-item-t {
                font-size: 0.26rem;
                height: 0.7rem;
            }

            .content-item-img {
                width: 2.93rem;
            }

            .content-item-list {
                position: unset;

                a {
                    padding: 0.1rem 0.2rem;
                    font-size: 0.14rem;
                }
            }
        }
    }
}
</style>